// =========================================================================
// JerseyFit Barbell — Photo Gallery
// -------------------------------------------------------------------------
// Add, remove, or reorder photos by editing the `photos` array below.
//
// Each photo is an object with:
//   - src:     the image URL (REQUIRED). You can host on any image URL —
//              the easiest is to upload to Facebook/Instagram and copy the
//              image URL, or use any public image link.
//   - caption: a short caption shown under the photo in the lightbox.
//
// Tips:
// - The first photo in the list shows up first.
// - You can add as many photos as you want — the grid will grow.
// - Use square or landscape photos for best look in the grid.
// =========================================================================

export const photos = [
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/1bmpmxc0_IMG_0252.jpg",
    caption: "Strongman corner — kegs, axle bar, yoke, and log press on the blue turf, JerseyFit mural overhead.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/cvb5q3ml_IMG_0253.jpg",
    caption: "Spirit Fitness stair climbers — step-mill cardio.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/x9dsnyfj_IMG_0255.jpg",
    caption: "Cardio lineup — recumbent bikes, treadmills, and stair climbers with mounted TVs.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/yzwncra7_IMG_0262.jpg",
    caption: "Trophy & achievements wall — powerlifting certificates, medals, and a fully-stocked drink fridge.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/4w5i77os_IMG_0254.jpg",
    caption: "Rack row honoring all military branches — every flag, every veteran represented.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/d3ttrbi7_IMG_0256.jpg",
    caption: "Power rack lineup — Titan racks, calibrated plates, and competition benches.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/t5icf08y_IMG_0261.jpg",
    caption: "Cardio room — Assault Runners, treadmills, and ellipticals.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/i6bcbohr_IMG_0263.jpg",
    caption: "Plate-loaded machine room — Body Masters and selectorized equipment.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/6ilm1kun_IMG_0272.jpg",
    caption: "Dumbbell room — full rack lineup with mirrored walls.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/yql5mo63_IMG_0273.jpg",
    caption: "Selectorized machines — Magnum, Body Masters, and more.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/o2360hdz_IMG_0274.jpg",
    caption: "Cable & Smith machine area with blue benches.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/01w75dm2_IMG_0275.jpg",
    caption: "Free-weight & machine corner — racks, benches, and dumbbells ready to go.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/kselujtg_IMG_0258.jpg",
    caption: "The JerseyFit state mural — Est. 2023 — kegs, slam balls, and the blue turf.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/zaptrjcv_IMG_0265.jpg",
    caption: "Specialty barbells set up on the blue turf — ready for PR day.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/tqek55pi_IMG_0266.jpg",
    caption: "The Jerseyfit wall — plate tree, specialty bars, and rack space.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/kgc22g4i_IMG_0267.jpg",
    caption: "Wide view of the gym — turf, racks, and the iron lined up.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/l2lwzhfg_IMG_0269.jpg",
    caption: "PR board — top squat, bench, and deadlift numbers for Men & Women.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/la2lihu8_IMG_0270.jpg",
    caption: "Machine room — leg press, hack squat, and selectorized equipment.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/inmdkaxm_Screenshot%202026-04-14%20161752.png",
    caption: "The training floor — racks, platforms, and our blue turf.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/g621lqtv_Screenshot%202026-04-14%20161428.png",
    caption: "The Jerseyfit wall — barbells and competition bars ready to go.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/e6ey06ae_Screenshot%202026-04-14%20161545.png",
    caption: "The JerseyFit crew — our community is the heart of the gym.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/cla48isp_Screenshot%202026-04-14%20161357.png",
    caption: "Winged NJ mural — original artwork in the gym.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/47ayb25t_Screenshot%202026-04-14%20125312.png",
    caption: "JerseyFit Barbell — Est. 2023.",
  },
];
